import Button from "react-bootstrap/Button";
import "./index.css";

interface ButtonComponentV2Props {
  titel?: string;
  isDisabled?: boolean;
  type?: any;
  onClick?: any;
  icon?: any;
  color?: string;
  backgroundColor?: string;
  size?: "small" | "medium" | "large";
  isHidden?: boolean;
}

const getSizeStyles = (size: "small" | "medium" | "large") => {
  switch (size) {
    case "small":
      return {
        padding: "4px 12px",
        fontSize: "12px",
        borderRadius: "12px",
      };
    case "medium":
      return {
        padding: "8px 20px",
        fontSize: "14px",
        borderRadius: "20px",
      };
    case "large":
      return {
        padding: "12px 28px",
        fontSize: "16px",
        borderRadius: "28px",
      };
    default:
      return {};
  }
};

const ButtonComponentV2: React.FC<ButtonComponentV2Props> = ({
  titel,
  isDisabled,
  type,
  onClick,
  icon,
  color,
  backgroundColor,
  size = "medium",
  isHidden,
}) => {

  const sizeStyles = getSizeStyles(size);

  if (isHidden) {
    return null;
  }

  return (
    <Button
      style={{
        color: color || "#fff",
        backgroundColor: backgroundColor || "#000",
        ...sizeStyles,
      }}
      className={`mx-2 px-4 reusable-button-style align-items-center  ${isHidden ? "hidden" : ""
        }`}
      disabled={isDisabled}
      type={type}
      onClick={onClick}
    >
      <div className="reusable-button-container-styles reusable-button-no-wrap justify-content-center align-items-center">
        {icon} &nbsp;
        {titel}
      </div>
    </Button>
  );
};

export default ButtonComponentV2;
